import { FlexBox } from '@airship-platform/jam-web/components';
import { EnvironmentBanner } from '@airship-platform/airship-patterns';
import { Link, Typography } from '@mui/material';
import { Outlet } from 'react-router';
import logo from '../../assets/images/airship-logo.svg';
import ROUTE_PATHS from '../../routes/paths';

type BaseTemplateProps = {
  hasHeader?: boolean;
  helpEnabled?: boolean;
};

const RegistrationBaseTemplate: React.FC<BaseTemplateProps> = ({
  hasHeader,
  helpEnabled,
}) => {
  const HELP_EMAIL = 'support@airship.us';

  return (
    <FlexBox
      flexDirection="column"
      height={'100vh'}
      width={'100vw'}
      overflow={'hidden'}
      padding={'1.5rem'}
    >
      <FlexBox justifyContent={'space-between'} alignItems={'center'}>
        {hasHeader && (
          <Link href={ROUTE_PATHS.HOME}>
            <img src={logo} alt="Airship" width={150} height={50} />
          </Link>
        )}
        <EnvironmentBanner />
        {helpEnabled && (
          <FlexBox>
            <Typography variant="body2">
              Need help?{' '}
              <Link component="a" href={`mailto:${HELP_EMAIL}`}>
                Contact Airship
              </Link>
            </Typography>
          </FlexBox>
        )}
      </FlexBox>
      <Outlet />
    </FlexBox>
  );
};

export default RegistrationBaseTemplate;
